import { EventupdateattributevisualizerComponent } from "../../components/shared/eventupdateattributevisualizer/eventupdateattributevisualizer.component";
import { BaseEntityAttribute } from "./base-entity-attribute";

export class GenericAttribute extends BaseEntityAttribute {
  visualizerTag: string;

  public entity: any
  constructor(
    attributeName: string,
    mapEntityId: string,
    canUndock: boolean,
    canCollapse: boolean,
    order: number,
    visualizerTag: string
  ) {
    super(attributeName, mapEntityId, canUndock, canCollapse, order);
    this.visualizerTag = visualizerTag;
  }

  override getVisualizer(): any {
    if(this.visualizerTag === 'eventupdateattributevisualizer'){
      return {
        component: EventupdateattributevisualizerComponent,
        inputs: { entity: this.mapEntityId }
      };
    }else{
      return `<${this.visualizerTag} mapentityId='${this.mapEntityId}'></${this.visualizerTag}>`;
    }
   
  } 
}